export default __webpack_public_path__ + "static/media/Protect.c75417d5.svg";